import { ReferenceInput, AutocompleteInput, useInput } from 'react-admin';
import { GroupQuickCreate } from '../../groups/GroupQuickCreate.tsx';

const ReferredByGroupInput = () => {
  const {
    field: { value: selectedId }
  } = useInput({ source: 'referredByGroupId' });

  return (
    <ReferenceInput
      source="referredByGroupId"
      reference="groups"
      // ReferenceInput defaults to id DESC, which put newest groups first.
      sort={{ field: 'name', order: 'ASC' }}
      fullWidth
      filter={{ includeSubgroups: true, id: selectedId ? [selectedId] : undefined }}
    >
      <AutocompleteInput
        label="Referred By Group"
        optionText={(record) => `${record.name}`}
        filterToQuery={(searchText) => {
          const base = { q: searchText, includeSubgroups: true };
          return selectedId ? { ...base, id: [selectedId] } : base;
        }}
        helperText={false}
        create={<GroupQuickCreate />}
        createLabel="Add a new group"
      />
    </ReferenceInput>
  );
};

export default ReferredByGroupInput;
